<template>
  <div class="notification cursor-pointer p-2 border-b">
    <div
      class="notif-2 flex photow-full bg-white mt-2 p-4 mb-2 rounded"
    >
      <div class="rounded-full">
        <p
          v-if="!image"
          class="rounded-full none-image"
        />
        <p
          v-if="image"
          class="rounded-full has-image"
        >
          <img
            v-if="image"
            :src="image"
            alt="profile picture"
            class="profil-image h-full w-full rounded-full"
          >
        </p>
      </div>
      <div class="w-5/6 pl-4">
        <p class="text-base font-bold">
          <span><span class="sender">{{ interlocuteurDetails.fullname }}</span></span>
        </p><br>
        <p class="text-base font-light -mt-3">
          <read-more
            class="read-more-component"
            more-str=""
            :text="interlocuteur.lastmsg.content"
            less-str=""
            :max-chars="25"
          />
        </p>
      </div>
      <div class="pt-6 w-1/2  text-right">
        <h5 class="font-light text-sm -mt-4" v-if="typeof interlocuteur.lastmsg.dateTimeTimestamp == 'undefined'">
          {{ getDateFormat(interlocuteur.lastmsg.sentAtDay + ' ' + interlocuteur.lastmsg.sentAt)  }}
        </h5>
        <h5 class="font-light text-sm -mt-4" v-if="typeof interlocuteur.lastmsg.dateTimeTimestamp != 'undefined'">
          {{ getDateFormat(interlocuteur.lastmsg.dateTimeTimestamp)  }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import { firebaseRef } from '../../../rema-function/firebaseRef'
import { firebaseDb } from '../../../main'
import firebaseStorage from '../../../rema-function/firebaseStorage'
import moment from 'moment'
import firebase from 'firebase'
export default {
  name: 'NotificationListInChat',
  props: [
    'interlocuteur',
    'guestUid'
  ],
  data () {
    return {
      image: '',
      interlocuteurDetails: {},
      campaign: {}
    }
  },
  computed: {
    interlocuteurIsSender: function () {
      // return (this.interlocuteur.lastmsg.from === this.currentUserUid)
      // alert(firebase.auth().currentUser.uid)
      return !(this.interlocuteur.lastmsg.from === firebase.auth().currentUser.uid)
    }
  },
  async created () {
    // alert(firebase.auth().currentUser.uid)

    let self = this
    await firebaseDb.ref(firebaseRef.users + this.guestUid + '/').once('value', function (snapshot) {
      self.interlocuteurDetails = snapshot.val()
    })
    firebaseStorage.getAvatar(this.guestUid).then(function (url) {
      if (url) {
        // this.$set(this.selectedUserStorage, 'iden', url)
        self.image = url
        //  alert(self.image)
      }
    }).catch(function (error) {
      if (error) console.log(error)
    })
  },
  methods: {
    getDateFormat: function (date) {
      moment.locale('fr')
      let re = /dernier/gi
      if (moment(date).calendar().includes(`Aujourd’hui à`)) {
        return (moment(date).fromNow().includes(`il y a quelques secondes`) || moment(date).fromNow().includes(`il y a une minute`)) ? moment(date).fromNow().replace(`il y a quelques secondes`, `à l'instant`) : moment(date).fromNow()
      }
      return moment(date).calendar().replace(re, ``)
    }
  },
  firebase () {
    return {
      campaign: firebaseDb.ref(firebaseRef.mainsAdsFeeds).child(this.interlocuteur.campaignId)
      //  interlocuteurDetails: firebaseDb.ref(firebaseRef.users + this.guestUid + '/')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/mixin";
  .notification {
    .sender {
      color: $black;
    }
    .campaign {
      background-color: $light_gray3;
      min-width: 14rem;
    }
    /*  .notif-2:hover {
      background-color: $light_gray2;
    }*/
    .profil-image {
      // height: 2.5rem;
     // width: 3rem;
      // border-radius: 50%;
    }
    .none-image {
      height: 2rem;
      background-color: $Green-Rema;
      width: 2rem;
    }
    .has-image {
      height: 2.1rem;
      width: 2.1rem;
    }
    .has-unread {
      background-color: $light_gray2;
    }
  }
</style>
